// SPDX-License-Identifier: Apache-2.0
//工具类：火狐、谷歌、苹果、edge浏览器的判断、Uuid、sysInfo的创建和返回。
//sysInfo的返回信息及格式： Format: {sdk:{version:**, type:**}, runtime:{version:**, name:**}, os:{version:**, name:**}};
"use strict";
const sdkVersion = "4.1";
import { localStorages } from "./storage/localStorage";
export function isFirefox() {
  return window.navigator.userAgent.match("Firefox") !== null;
}
export function isChrome() {
  return window.navigator.userAgent.match("Chrome") !== null;
}
export function isSafari() {
  return /^((?!chrome|android).)*safari/i.test(window.navigator.userAgent);
}
export function isEdge() {
  return window.navigator.userAgent.match(/Edge\/(\d+).(\d+)$/) !== null;
}
export function createUuid() {
  return "xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx".replace(/[xy]/g, function(c) {
    var r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
/*设置全屏*/
export function fullScreen(element) {
  console.log(`全屏`);
  // var element = document.getElementById(`${element}`);
  var element = document.body;
  if (element.requestFullscreen) {
    element.requestFullscreen();
  } else if (element.msRequestFullscreen) {
    element.msRequestFullscreen();
  } else if (element.mozRequestFullScreen) {
    element.mozRequestFullScreen();
  } else if (element.webkitRequestFullscreen) {
    element.webkitRequestFullscreen();
  }
}
/*退出全屏*/
export async function exitFullscreen() {
  console.log(`退出全屏`);
  if (document.exitFullscreen) {
    return new Promise((resolve, reject) => {
      document
        .exitFullscreen()
        .then(() => console.log("Document Exited form Full screen mode"))
        .catch(err => {
          reject();
        });
    });
  } else if (document.webkitCancelFullScreen) {
    document.webkitCancelFullScreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen();
  }
}
/*判断是否全屏*/
export function checkFull() {
  var isFull =
    document.fullscreenElement ||
    document.mozFullScreenElement ||
    document.webkitFullscreenElement;
  //  document.fullScreen ||  window.fullScreen || document.webkitIsFullScreen || document.msFullscreenEnabled || document.mozIsFullScreen;
  // if(isChrome()){
  //     if (document.body.scrollHeight === window.screen.height && document.body.scrollWidth === window.screen.width) {
  //         isFull = true
  //     } else {
  //         isFull = false
  //     }
  // }else{
  //     if (window.outerHeight === window.screen.height && window.outerWidth === window.screen.width) {
  //         isFull = true
  //     } else {
  //         isFull = false
  //     }
  // }
  if (isFull === undefined) {
    console.log("非全屏状态");
    isFull = false;
  }
  return isFull;
}
// Returns system information.
// Format: {sdk:{version:**, type:**}, runtime:{version:**, name:**}, os:{version:**, name:**}};
export function sysInfo() {
  var info = Object.create({});
  info.sdk = {
    version: sdkVersion,
    type: "JavaScript"
  };
  // Runtime info.
  var userAgent = navigator.userAgent;
  var firefoxRegex = /Firefox\/([0-9\.]+)/;
  var chromeRegex = /Chrome\/([0-9\.]+)/;
  var edgeRegex = /Edge\/([0-9\.]+)/;
  var safariVersionRegex = /Version\/([0-9\.]+) Safari/;
  var result = chromeRegex.exec(userAgent);
  if (result) {
    info.runtime = {
      name: "Chrome",
      version: result[1].split(".")[0]
    };
  } else if ((result = firefoxRegex.exec(userAgent))) {
    info.runtime = {
      name: "Firefox",
      version: result[1]
    };
  } else if ((result = edgeRegex.exec(userAgent))) {
    info.runtime = {
      name: "Edge",
      version: result[1]
    };
  } else if (isSafari()) {
    result = safariVersionRegex.exec(userAgent);
    info.runtime = {
      name: "Safari"
    };
    info.runtime.version = result ? result[1] : "Unknown";
  } else {
    info.runtime = {
      name: "Unknown",
      version: "Unknown"
    };
  }
  // OS info.
  var windowsRegex = /Windows NT ([0-9\.]+)/;
  var macRegex = /Intel Mac OS X ([0-9_\.]+)/;
  var iPhoneRegex = /iPhone OS ([0-9_\.]+)/;
  var linuxRegex = /X11; Linux/;
  var androidRegex = /Android( ([0-9\.]+))?/;
  var chromiumOsRegex = /CrOS/;
  if ((result = windowsRegex.exec(userAgent))) {
    info.os = {
      name: "windows",
      version: result[1]
    };
  } else if ((result = macRegex.exec(userAgent))) {
    info.os = {
      name: "mac",
      version: result[1].replace(/_/g, ".")
    };
  } else if ((result = iPhoneRegex.exec(userAgent))) {
    info.os = {
      name: "iPhone OS",
      version: result[1].replace(/_/g, ".")
    };
  } else if ((result = linuxRegex.exec(userAgent))) {
    info.os = {
      name: "Linux",
      version: "Unknown"
    };
  } else if ((result = androidRegex.exec(userAgent))) {
    info.os = {
      name: "Android",
      version: result[1] || "Unknown"
    };
  } else if ((result = chromiumOsRegex.exec(userAgent))) {
    info.os = {
      name: "Chrome OS",
      version: "Unknown"
    };
  } else {
    info.os = {
      name: "Unknown",
      version: "Unknown"
    };
  }
  info.capabilities = {
    continualIceGathering: false,
    unifiedPlan: false,
    streamRemovable: info.runtime.name !== "Firefox"
  };
  return info;
}
export function compateBrowser() {
  let systemInfo = sysInfo();
  if (
    systemInfo.runtime.name == "Unknown" ||
    (systemInfo.runtime.name == "Firefox" &&
      JSON.parse(systemInfo.runtime.version) < 70) ||
    (systemInfo.runtime.name == "Chrome" &&
      JSON.parse(systemInfo.runtime.version) <= 65)
  ) {
    return {
      code: 1
    };
  } else {
    return {
      code: 0
    };
  }
}
export function isSupportShare() {
  let systemInfo = sysInfo();
  if (
    systemInfo.runtime.name == "Chrome" ||
    systemInfo.runtime.name == "Firefox"
  ) {
    return true;
  } else {
    return false;
  }
}
export function changeTime(time) {
  var getTime = handelTime(time);

  if (getTime) {
    var oTime =
      getTime.oYear +
      "-" +
      getTime.oMonth +
      "-" +
      getTime.oDay +
      " " +
      getTime.oHour +
      ":" +
      getTime.oMin +
      ":" +
      getTime.oSen; //拼接时间
    return oTime;
  } else {
    return "";
  }
}
export function getTime(time) {
  var getTime = handelTime(time);
  var curDate = new Date();

  if (getTime) {
    if (curDate.getFullYear() != getTime.oYear) {
      var oTime =
        getTime.oYear +
        "-" +
        getTime.oMonth +
        "-" +
        getTime.oDay +
        " " +
        getTime.oHour +
        ":" +
        getTime.oMin +
        ":" +
        getTime.oSen; //拼接时间
      return oTime;
    } else if (
      curDate.getDate() == getTime.oDay &&
      curDate.getMonth() + 1 == getTime.oMonth
    ) {
      var oTime = getTime.oHour + ":" + getTime.oMin;
      return oTime;
    } else {
      var oTime =
        getTime.oMonth +
        "-" +
        getTime.oDay +
        " " +
        getTime.oHour +
        ":" +
        getTime.oMin;
      return oTime;
    }
  } else {
    return "";
  }
}
function handelTime(time) {
  time =
    JSON.stringify(time).length == 10
      ? JSON.parse(JSON.stringify(time) + "000")
      : time;
  if (time) {
    var oDate = new Date(time * 1),
      oYear = oDate.getFullYear(),
      oMonth = getBz(oDate.getMonth() + 1),
      oDay = getBz(oDate.getDate()),
      oHour = getBz(oDate.getHours()),
      oMin = getBz(oDate.getMinutes()),
      oSen = getBz(oDate.getSeconds());
    return { oYear, oMonth, oDay, oHour, oMin, oSen };
  } else {
    return "";
  }
}
//补0
function getBz(num) {
  if (parseInt(num) < 10) {
    num = "0" + num;
  }
  return num;
}
export function isNull(str) {
  if (str == "" || str == null || str == undefined) return true;
  var regu = "^[ ]+$";
  var re = new RegExp(regu);
  return re.test(str);
}
/**
 * 设置用户在会中标识：每30秒刷新一下loginIngo中的时间戳
 * ***/
var LoginInfoTimer = null;
export async function setLoginInfoTimer(uid) {
  if (LoginInfoTimer) {
    clearInterval(LoginInfoTimer);
  }
  let loginInfo = localStorages.get(`loginInfo_${uid}`);
  console.log(loginInfo);
  if (loginInfo) {
    loginInfo.timestamp = new Date().getTime();
    await localStorages.set(`loginInfo_${uid}`, loginInfo);
  }
  LoginInfoTimer = setInterval(() => {
    let loginInfo = localStorages.get(`loginInfo_${uid}`);
    if (loginInfo) {
      loginInfo.timestamp = new Date().getTime();
      localStorages.set(`loginInfo_${uid}`, loginInfo);
    }
  }, 30000);
}
/**退出会议，关闭浏览器、关闭页签清除会中计时及删除时间戳**/
export function clearLoginInfoTimer(uid) {
  let loginInfo = localStorages.get(`loginInfo_${uid}`);
  console.log(loginInfo);
  if (loginInfo && loginInfo.timestamp) {
    delete loginInfo.timestamp;
    localStorages.set(`loginInfo_${uid}`, loginInfo);
  }
  if (LoginInfoTimer) {
    clearInterval(LoginInfoTimer);
  }
}

export function delCurUserLoginRoomId(uid) {
  let loginInfo = localStorages.get(`loginInfo_${uid}`);
  if (loginInfo && loginInfo.roomId) {
    delete loginInfo.roomId;
    localStorages.set(`loginInfo_${uid}`, loginInfo);
  }
}
export function downSortcompare(property) {
  return function(a, b) {
    var value1 = a[property];
    var value2 = b[property];
    return value2 - value1;
  };
}
export function upSortcompare(property) {
  return function(a, b) {
    var value1 = a[property];
    var value2 = b[property];
    return value1 - value2;
  };
}
export function transferMeanhtml(string) {
  var newString = string.replace(/</g, "&lt;");
  newString = newString.replace(/>/g, "&gt;");
  return newString;
}
export function showDeskTopNotice(title, msg) {
  var Notification =
    window.Notification || window.mozNotification || window.webkitNotification;
  if (Notification) {
    Notification.requestPermission(function(status) {
      //status默认值'default'等同于拒绝 'denied' 意味着用户不想要通知 'granted' 意味着用户同意启用通知
      if ("granted" != status) {
        return;
      } else {
        var tag = "sds" + Math.random();
        var notify = new Notification(title, {
          dir: "auto",
          lang: "zh-CN",
          requireInteraction: true,
          tag: tag, //实例化的notification的id
          icon: "https://cv.263.net/static/logo.ico", //通知的缩略图,//icon 支持ico、png、jpg、jpeg格式
          body: msg //通知的具体内容
        });
        (notify.onclick = function() {
          //如果通知消息被点击,通知窗口将被激活
          window.focus();
          notify.close();
          //打开对应的界面
          // $("#v" + id + " .visit_content").trigger("click");
        }),
          (notify.onerror = function() {
            console.log("HTML5桌面消息出错！！！");
          });
        notify.onclose = function() {
          console.log("HTML5桌面消息关闭！！！");
        };
      }
    });
  } else {
    console.log("您的浏览器不支持桌面消息");
  }
}
export function stripscript(s)
{
var pattern = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？]")
var rs = "";
if(s){
	for (var i = 0; i < s.length; i++) {
	rs = rs+s.substr(i, 1).replace(pattern, '');
	}
}
return rs;

}